import { parse, stringify } from 'query-string';
import { removeUndef } from '@catalogo/core-helpers/utils';

export const formatFilters = searchQs => {
  const search = parse(searchQs);

  const filter = search.filter || search.filtro;

  if (!filter) {
    return [];
  }

  try {
    if (typeof filter === 'string') {
      return Array.isArray(JSON.parse(filter)) ? JSON.parse(filter) : [JSON.parse(filter)];
    }
    return filter.map(JSON.parse);
  } catch (e) {
    return [];
  }
};

export const applyFilters = (props, filters, conteudo) => () => {
  const { match, history, parsedQs = {} } = props;
  const { rc, context } = parsedQs;
  const qs = filters.map(filter => `filter={"id":"${filter.id}","value":"${filter.value}","fixed":true}`).join('&');
  const additionalQS = stringify(removeUndef({ rc, context }));
  const additionalContent = conteudo ? `&conteudo=${conteudo}` : '';
  history.push(`${match.url}?${additionalQS ? `${additionalQS}&` : ''}${qs}${additionalContent}`);
};

export const toggleFilter = (filters, setFilters) => params => {
  if (isFilterSelected(filters)(params)) {
    const f = filters.filter(filter => !(filter.id === params.id && filter.value === params.value));

    return setFilters(f);
  }
  filters.push(params);

  return setFilters([...filters]);
};

export const isFilterSelected = filters => value => {
  if (!value) {
    return false;
  }

  return filters.some(filter => filter.id === value.id && filter.value === value.value);
};
